import { useState } from "react";

const announcements = [
  "NOVA COLEÇÃO 2026 - DISPONÍVEL AGORA",
  "ATENDIMENTO VIA WHATSAPP: (11) 92316-9450",
  "PEÇAS EXCLUSIVAS COM MODELAGEM PREMIUM",
];

const benefits = [
  { icon: "ri-bank-card-line", title: "Parcelamento", desc: "Em até 5x sem juros" },
  { icon: "ri-truck-line", title: "Frete Grátis", desc: "Compras acima de R$ 199,99" },
  { icon: "ri-whatsapp-line", title: "Atendimento", desc: "Via WhatsApp" },
  { icon: "ri-arrow-go-back-line", title: "Devolução Grátis", desc: "Até 7 dias após recebido" },
  { icon: "ri-shield-check-line", title: "Site Seguro", desc: "Compre com segurança" },
];

export default function AnnouncementBar() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((c) => (c - 1 + announcements.length) % announcements.length);
  const next = () => setCurrent((c) => (c + 1) % announcements.length);

  return (
    <>
      {/* Top announcement ticker */}
      <div className="bg-black text-white text-[11px] tracking-[0.15em] font-light py-2 flex items-center justify-center relative select-none">
        <button
          onClick={prev}
          className="absolute left-4 cursor-pointer hover:opacity-60 transition-opacity"
          aria-label="Anterior"
        >
          <i className="ri-arrow-left-s-line text-sm" />
        </button>
        <span className="px-10">{announcements[current]}</span>
        <button
          onClick={next}
          className="absolute right-4 cursor-pointer hover:opacity-60 transition-opacity"
          aria-label="Próximo"
        >
          <i className="ri-arrow-right-s-line text-sm" />
        </button>
      </div>

    </>
  );
}
